/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Form, Input, InputNumber, InputProps } from "antd";
import TextArea, { TextAreaProps } from "antd/es/input/TextArea";
import { useState } from "react";
import { Rule } from "antd/es/form";

export function FormInput({
  id,
  name = "",
  label = "",
  placeholder = "",
  required = false,
  rules = undefined,
  widthSize = "medium",
  textArea = 0,
  inputType = "text",
  value = "",
  onChange = () => {},
  rows = 4,
  maxLength = undefined,
  disableSpecialCharCheck = false,
  ...rest
}: any) {
  //console.log("rest: ", textArea);
  const spanSize =
    widthSize.toLowerCase() == "large"
      ? 24
      : widthSize.toLowerCase() == "small"
      ? 4
      : 8;
  //const specialCharRegex = /^[A-Za-z0-9-_?\\/:.,!(){}'"[\]\\\\s]*$/; //will fetch this from backend after api integration.

const [newRules] = useState<Rule[]>(() => {
  const isNumberInput = inputType?.toLowerCase() === 'number';

  if (isNumberInput) {
    // For numeric input, return rules as-is
    return (rules || []).map((rule) => {
      const result: Rule = {};
      if (rule.required?.toString().toLowerCase() === 'true') {
        result.required = true;
      }
      if (rule.min !== undefined) {
        result.min = rule.min;
      }
      if (rule.max !== undefined) {
        result.max = rule.max;
      }
      result.type = 'number';
      result.message = rule.customErrorMessage || `${label} Must be a valid number.`;
      return result;
    });
  } else {
    // For non-number inputs, use regex and whitespace logic
    const finalRules: Rule[] = [];

    (rules || []).forEach((rule) => {
      if (rule.required?.toString().toLowerCase() === 'true') {
        finalRules.push({ required: true });
      }

      if (rule.min !== undefined) {
        finalRules.push({ min: rule.min });
      }

      if (rule.max !== undefined) {
        finalRules.push({ max: rule.max });
      }

      if (rule.regex) {
        try {
          const patternBody = rule.regex.replace(/^\/|\/$/g, '');
          finalRules.push({
            pattern: new RegExp(patternBody),
            message: rule.customErrorMessage || `Invalid ${label} format.`,
          });
        } catch (err) {
          console.error('Invalid regex pattern:', rule.regex);
        }
      }
    });

    // Add "not only whitespace" rule
    finalRules.push({
      pattern: /^(?!\s*$).+/,
      message: `${label} cannot be empty or just spaces.`,
    });

    return finalRules;
  }
});

  const widthPercentage: string = (() => {
    switch (widthSize.toLowerCase()) {
      case "medium":
        return "100%";
      case "small":
        return "100%";
      default:
        return "100%";
    }
  })();
  return (
    <Form.Item label={label} name={name} rules={newRules} layout="vertical">
      {textArea ? (
        <TextArea
          showCount
          maxLength={maxLength !== null ? maxLength : undefined}
          placeholder={placeholder}
          autoComplete="off"
          value={value}
          onChange={onChange}
          rows={rows || 4}
          style={{ width: widthPercentage }}
          {...(rest as TextAreaProps)}
        />
      ) : inputType.toLowerCase() == "number" ? (
        <InputNumber
          placeholder={placeholder}
          min={0}
          autoComplete="off"
          // value={value}
          value={Number(value) || 0} // Ensure value is always a valid number
          onChange={onChange}
          style={{ width: widthPercentage }}
          onKeyDownCapture={(e) => {
            // Allow only numeric keys, control keys, and the decimal point
            if (
              !/[0-9]/.test(e.key) &&
              e.key !== "Backspace" &&
              e.key !== "Delete" &&
              e.key !== "Tab" &&
              e.key !== "ArrowLeft" &&
              e.key !== "ArrowRight" &&
              e.key !== "Enter"
            ) {
              e.preventDefault();
            }
          }}
          {...(rest as any)}
        />
      ) : (
        <Input
          placeholder={placeholder}
          autoComplete="off"
          onChange={onChange}
          value={value}
          style={{ width: widthPercentage }}
          {...(rest as InputProps)}
        />
      )}
    </Form.Item>
  );
}
